export const GET_SUBSCRIBERS = {
  BEGIN: 'GET_SUBSCRIBERS_BEGIN',
  SUCCESS: 'GET_SUBSCRIBERS_SUCCESS',
  FAILURE: 'GET_SUBSCRIBERS_FAILURE'
}

export const ADD_SUBSCRIBER = {
  BEGIN: 'ADD_SUBSCRIBER_BEGIN',
  SUCCESS: 'ADD_SUBSCRIBER_SUCCESS',
  FAILURE: 'ADD_SUBSCRIBER_FAILURE'
}

export const DELETE_SUBSCRIBER = {
  BEGIN: 'DELETE_SUBSCRIBER_BEGIN',
  SUCCESS: 'DELETE_SUBSCRIBER_SUCCESS',
  FAILURE: 'DELETE_SUBSCRIBER_FAILURE'
}

export const EDIT_SUBSCRIBER = {
  BEGIN: 'EDIT_SUBSCRIBER_BEGIN',
  SUCCESS: 'EDIT_SUBSCRIBER_SUCCESS',
  FAILURE: 'EDIT_SUBSCRIBER_FAILURE'
}
